// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ecf19180","239":"49074fb5","455":"1eba8f34"}[chunkId] + ".chunk.js";
};